import { Col, Container, Row } from "react-bootstrap";
import ArticleCard from "./tax-updates/ArticleCard";
import useLang from "hooks/useLang";
import { useEffect, useState, useCallback } from "react";
import { useAdminClient } from "hooks/useAdminClient";

const RecentArticles = () => {
  const { lang } = useLang();
  const client = useAdminClient();
  const [articles, setArticles] = useState([])
  const fetchData = useCallback(async (params)  => {
    const queryParams = new URLSearchParams();
    queryParams.set('limit', 6)
    queryParams.set('order', 'DESC')
    const response = await client.get(`/be/api/v1/front-end/articles/getList?${queryParams}`);
    const {articles: data} = response.data;
    setArticles(data);
  }, [])
  useEffect(() => {
    fetchData();
  }, [fetchData])

  return (
    <section className="section recent-articles" id="recent-articles">
      <Container>
        <Row>
          <Col lg={12}>
            <div className="sec-hd-custom">
              <h2 className="sec-title">{lang.recent_articles.section_title}</h2>
            </div>
          </Col>
        </Row>
        <Row>
          {articles.map(post => {
            return <Col md={4}>
            <ArticleCard
              id={post.id}
              cardImage={post.cardImage}
              cardTitle={post.cardTitle}
              cardText={post.cardText}
              date={post.date}
              creator={post.creator}
            />
          </Col>
          })}
        </Row>
      </Container>
    </section>
  );
};

export default RecentArticles;
